<div class="account-shell__content">
  <div class="account-shell__content-wrapper pl-3 pr-3">
    <div class="grid align-items-end" [ngClass]="(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'mb-3'">
      <div class="col-4 col-sm-12 no-padding">
        <div class="account-shell__forms-input" [ngClass]="(deviceValue | async) === DTypes.Mobile ? 'mt-2' : 'pr-2'">
          <div class="ui-input__placeholder"><p>С даты</p></div>
          <div class="ui-input ui-input__text"><input type="date" [(ngModel)]="from" [ngModelOptions]="{standalone: true}" /></div>
        </div>
      </div>
      <div class="col-4 col-sm-12 no-padding">
        <div class="account-shell__forms-input" [ngClass]="(deviceValue | async) === DTypes.Mobile ? 'mt-2' : 'pl-2 pr-2'">
          <div class="ui-input__placeholder"><p>По дату</p></div>
          <div class="ui-input ui-input__text"><input type="date" [(ngModel)]="to" [ngModelOptions]="{standalone: true}" /></div>
        </div>
      </div>
      <div class="col-4 col-sm-12 no-padding">
        <div class="account-shell__forms-input" [ngClass]="(deviceValue | async) === DTypes.Mobile ? 'mt-2' : 'pl-2'">
          <div class="ui-input__placeholder"><p>Статус</p></div>
          <p-dropdown
            [options]="statusOptions"
            optionLabel="name"
            optionValue="value"
            [(ngModel)]="status"
            [ngModelOptions]="{standalone: true}"
            [showClear]="false"
            styleClass="p-dropdown__bulletins">
          </p-dropdown>
        </div>
      </div>
    </div>

    <div class="grid mb-3">
      <div class="col-auto pr-2">
        <button type="button" class="ui-buttons ui-buttons__blue-large" (click)="onApplyFilters()" [disabled]="loading">Применить</button>
      </div>
      <div class="col-auto">
        <button type="button" class="ui-buttons ui-buttons__light-large" (click)="onResetFilters()" [disabled]="loading">Сбросить</button>
      </div>
    </div>

    <p class="txt-caption" *ngIf="loadError">{{ loadError }}</p>
    <div class="grid justify-content-center py-4" *ngIf="loading">
      <div class="ui-loader ui-loader__page-light"></div>
    </div>

    <div *ngIf="!loading && !loadError">
      <div class="account-hirings__empty txt-caption" *ngIf="!items.length">Заявок не найдено.</div>

      <div class="account-hirings__list" *ngIf="items.length">
        <div class="account-hirings__item" *ngFor="let item of items">
          <div class="account-hirings__row">
            <div class="account-hirings__avatar-wrap">
              <img
                *ngIf="performerPhoto(item) as photo"
                [src]="photo"
                alt=""
                class="account-hirings__avatar" />
              <div *ngIf="!performerPhoto(item)" class="account-hirings__avatar account-hirings__avatar-placeholder">
                <span class="mr-icon mr-icon-user">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </span>
              </div>
            </div>

            <div class="account-hirings__content">
              <h5 class="account-hirings__name">{{ item.performer?.name || 'Исполнитель' }}</h5>
              <p class="txt-caption account-hirings__date">Дата заявки: {{ formatHiringDate(item) }}</p>
              <p class="txt-caption account-hirings__message" *ngIf="item.message">Сообщение: {{ item.message }}</p>
              <p class="txt-caption account-hirings__conditions">Условия: {{ conditionsSummary(item) }}</p>
            </div>

            <div class="account-hirings__meta">
              <span class="account-hirings__status" [ngClass]="'account-hirings__status_' + statusClass(item.status)">
                {{ statusLabel(item.status) }}
              </span>
              <div class="account-hirings__actions">
                <button
                  *ngIf="canWithdraw(item)"
                  type="button"
                  class="ui-buttons ui-buttons__light-small"
                  (click)="confirmWithdraw(item)"
                  [disabled]="actionDisabled(item)">
                  Отменить приглашение
                </button>
                <button
                  *ngIf="canMarkResult(item)"
                  type="button"
                  class="ui-buttons ui-buttons__light-small"
                  (click)="confirmMarkPerformed(item)"
                  [disabled]="actionDisabled(item)">
                  Исполнено
                </button>
                <button
                  *ngIf="canMarkResult(item)"
                  type="button"
                  class="ui-buttons ui-buttons__light-small"
                  (click)="confirmMarkUnsuccessful(item)"
                  [disabled]="actionDisabled(item)">
                  Не состоялось
                </button>
                <button
                  *ngIf="canMarkResult(item)"
                  type="button"
                  class="ui-buttons ui-buttons__light-small"
                  (click)="showPerformerContacts(item)"
                  [disabled]="actionDisabled(item)">
                  Показать контакты
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="grid align-items-center mt-3" *ngIf="items.length && showPager">
        <div class="col-auto pr-2">
          <button type="button" class="ui-buttons ui-buttons__light-small" (click)="onPrevPage()" [disabled]="loading || page <= 1">Назад</button>
        </div>
        <div class="col-auto pr-2">
          <p class="txt-caption mb-0">Страница {{ page }}</p>
        </div>
        <div class="col-auto">
          <button type="button" class="ui-buttons ui-buttons__light-small" (click)="onNextPage()" [disabled]="loading || !hasMore">Вперед</button>
        </div>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog
  key="hirings"
  [appendTo]="'body'"
  [styleClass]="'p-dialog__confirm'">
</p-confirmDialog>

<p-dialog
  [(visible)]="contactsDialogVisible"
  [modal]="true"
  [dismissableMask]="true"
  [closable]="true"
  [style]="{ width: '90vw', maxWidth: '420px' }"
  styleClass="account-hirings__contacts-dialog"
  [header]="contactsDialogHeader()"
  appendTo="body"
  (onHide)="onContactsDialogHide()">
  <div class="account-hirings__contacts-body">
    <div class="grid justify-content-center py-3" *ngIf="contactsLoading">
      <div class="ui-loader ui-loader__page-light"></div>
    </div>
    <p class="txt-caption account-hirings__contacts-error" *ngIf="!contactsLoading && contactsLoadError">{{ contactsLoadError }}</p>
    <ng-container *ngIf="!contactsLoading && !contactsLoadError && contactsProfile as prof">
      <div class="account-hirings__contacts-phone-block" *ngIf="phoneImageUrl(prof) as phoneSrc">
        <p class="txt-caption account-hirings__contacts-label">Телефон</p>
        <img [src]="phoneSrc" alt="" class="account-hirings__contacts-phone-img" />
      </div>
      <div
        class="account-hirings__contacts-messengers"
        *ngIf="prof.bookingPhone?.hasTelegram || prof.bookingPhone?.hasMax">
        <p class="txt-caption account-hirings__contacts-label">Мессенджеры</p>
        <div class="account-hirings__contacts-messenger-icons">
          <span
            *ngIf="prof.bookingPhone?.hasTelegram"
            class="mr-icon mr-icon-telegram-color account-hirings__messenger-icon"
            title="Telegram">
            <span class="path1"></span><span class="path2"></span>
          </span>
          <span
            *ngIf="prof.bookingPhone?.hasMax"
            class="mr-icon mr-icon-max-color account-hirings__messenger-icon"
            title="Max">
            <span class="path1"></span><span class="path2"></span>
          </span>
        </div>
      </div>
      <div class="account-hirings__contacts-social" *ngIf="prof.socialLinks?.length">
        <p class="txt-caption account-hirings__contacts-label">Ссылки и мессенджеры</p>
        <ul class="account-hirings__contacts-social-list">
          <li *ngFor="let link of prof.socialLinks" class="account-hirings__contacts-social-item">
            <a
              *ngIf="link.url"
              [href]="link.url"
              target="_blank"
              rel="noopener noreferrer"
              class="account-hirings__contacts-social-link">
              <ng-container *ngIf="platformForLink(link) as pv">
                <span *ngIf="getPlatformIcon(pv).type === 'font'" [class]="getPlatformIcon(pv).iconClass" class="account-hirings__contacts-social-icon-font">
                  <span class="path1"></span><span class="path2"></span>
                  <span class="path3" *ngIf="(getPlatformIcon(pv).paths || 0) >= 3"></span>
                  <span class="path4" *ngIf="(getPlatformIcon(pv).paths || 0) >= 4"></span>
                </span>
                <img
                  *ngIf="getPlatformIcon(pv).type === 'svg'"
                  [src]="getPlatformIcon(pv).src"
                  class="account-hirings__contacts-social-icon-img"
                  alt="" />
              </ng-container>
              <span class="account-hirings__contacts-social-text">{{ platformLabel(link) }}</span>
            </a>
          </li>
        </ul>
      </div>
      <p class="txt-caption account-hirings__contacts-empty" *ngIf="!contactsHasAny(prof)">
        Исполнитель не указал контакты в профиле.
      </p>
    </ng-container>
  </div>
</p-dialog>
